import axiosInstance from "auth/FetchInterceptor";
import { KE_HOACH_MUA_HANG_API, DANHMUC_API } from "constants/ApiConstant";
const KeHoachMuaHangService = {};

// start kehoachmuahang

KeHoachMuaHangService.getbyid = function (id) {
  return axiosInstance.get(`${KE_HOACH_MUA_HANG_API}?id=${id}`, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};
KeHoachMuaHangService.create = function (data) {
  return axiosInstance.post(`${KE_HOACH_MUA_HANG_API}`, data, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};
KeHoachMuaHangService.getall = function (data) {
  return axiosInstance.post(`${KE_HOACH_MUA_HANG_API}/get-all`, data, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};
KeHoachMuaHangService.GetAllKeHoach = function (id) {
  return axiosInstance.get(`${KE_HOACH_MUA_HANG_API}/get-all-ke-hoach`, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};
KeHoachMuaHangService.update = function (data) {
  return axiosInstance.put(`${KE_HOACH_MUA_HANG_API}`, data, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};
KeHoachMuaHangService.delete = function (id) {
  return axiosInstance.delete(`${KE_HOACH_MUA_HANG_API}?id=${id}`, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};

// gửi yêu cầu xử lý đơn

// end kehoachmuahang

// start chitietkehoachmuahang
KeHoachMuaHangService.createChiTiet = function (data) {
  return axiosInstance.post(`${KE_HOACH_MUA_HANG_API}/chi-tiet`, data, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};

KeHoachMuaHangService.getDsChiTietByID = function (id) {
  return axiosInstance.get(`${KE_HOACH_MUA_HANG_API}/chi-tiet?id=${id}`, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};

KeHoachMuaHangService.deleteDeXuatChiTiet = function (id) {
  return axiosInstance.delete(`${KE_HOACH_MUA_HANG_API}/chi-tiet?id=${id}`, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};

KeHoachMuaHangService.getDmHangHoa = function (data) {
  return axiosInstance.post(`${DANHMUC_API}/get-dmhanghoa`, data, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};

KeHoachMuaHangService.ExportKeHoachMuaHang = function (data) {
  return axiosInstance.post(`${KE_HOACH_MUA_HANG_API}/export-excel`, data, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};

KeHoachMuaHangService.getGiaNhapGanNhat = function (data) {
  return axiosInstance.post(
    `${KE_HOACH_MUA_HANG_API}/chi-tiet/gia-nhap-gan-nhat`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

KeHoachMuaHangService.xacNhanChiTiet = function (data) {
  return axiosInstance.put(`${KE_HOACH_MUA_HANG_API}/chi-tiet/xac-nhan`, data, {
    baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
  });
};

// end chitietkehoachmuahang

//ke-hoach-thanh-toan

KeHoachMuaHangService.getbyidthanhtoan = function (id) {
  return axiosInstance.get(
    `${KE_HOACH_MUA_HANG_API}/getid-ke-hoach-thanh-toan?id=${id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
KeHoachMuaHangService.createthanhtoan = function (data) {
  return axiosInstance.post(
    `${KE_HOACH_MUA_HANG_API}/insert-ke-hoach-thanh-toan`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
KeHoachMuaHangService.getallthanhtoan = function (data) {
  return axiosInstance.post(
    `${KE_HOACH_MUA_HANG_API}/get-all-thanh-toan`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
KeHoachMuaHangService.GetAllKeHoachthanhtoan = function (id) {
  return axiosInstance.get(
    `${KE_HOACH_MUA_HANG_API}/get-all-ke-hoach-thanh-toan`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
KeHoachMuaHangService.updatethanhtoan = function (data) {
  return axiosInstance.put(
    `${KE_HOACH_MUA_HANG_API}/update-ke-hoach-thanh-toan`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
KeHoachMuaHangService.deletethanhtoan = function (id) {
  return axiosInstance.delete(
    `${KE_HOACH_MUA_HANG_API}/delete-ke-hoach-thanh-toan?id=${id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

// start chitietkehoachmuahang
KeHoachMuaHangService.createChiTietthanhtoan = function (data) {
  return axiosInstance.post(
    `${KE_HOACH_MUA_HANG_API}/chi-tiet-thanh-toan`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

KeHoachMuaHangService.getDsChiTietByIDthanhtoan = function (id) {
  return axiosInstance.get(
    `${KE_HOACH_MUA_HANG_API}/chi-tiet-thanh-toan?id=${id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

KeHoachMuaHangService.deleteDeXuatChiTietthanhtoan = function (id) {
  return axiosInstance.delete(
    `${KE_HOACH_MUA_HANG_API}/chi-tiet-thanh-toan?id=${id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

KeHoachMuaHangService.ExportKeHoachMuaHangthanhtoan = function (data) {
  return axiosInstance.post(
    `${KE_HOACH_MUA_HANG_API}/export-excel-thanh-toan`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

KeHoachMuaHangService.getGiaNhapGanNhatthanhtoan = function (data) {
  return axiosInstance.post(
    `${KE_HOACH_MUA_HANG_API}/chi-tiet-thanh-toan/gia-nhap-gan-nhat`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

KeHoachMuaHangService.xacNhanChiTietthanhtoan = function (data) {
  return axiosInstance.put(
    `${KE_HOACH_MUA_HANG_API}/chi-tiet-thanh-toan/xac-nhan`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

export default KeHoachMuaHangService;
